const MSP_CONFIG = {
  GA: {
    WEB: {
      category: 'WEB-articleshowv2',
      action: 'MSP_Affiliate_Link_WEB_Click',
    },
    MWEB: {
      category: 'WAP-articleshowv2',
      action: 'MSP_Affiliate_Link_WAP_Click',
    },
    APP: {
      category: 'APP-articleshowv2',
      action: 'MSP_Affiliate_Link_APP_Click',
    },
  },
};
export const HOTPICKS_CONFIG = {
  GA: {
    WEB: {
      category: 'WEB-articleshowv2',
      action: 'Hotpicks_Affiliate_Link_WEB_Click',
    },
    MWEB: {
      category: 'WAP-articleshowv2',
      action: 'Hotpicks_Affiliate_Link_WAP_Click',
    },
    APP: {
      category: 'APP-articleshowv2',
      action: 'Hotpicks_Affiliate_Link_APP_Click',
    },
  },
};

export default MSP_CONFIG;
